const staging = {
  env: 'staging',
  backendUrl: 'https://ctt-clientes.redradix.com/',
  hasDebug: false,
  hasMocks: false,
  isTest: false,
}

export default staging
